import axios from "axios";
import authService from "../services/authService.js";

// Tạo axios instance chung với cấu hình cơ bản
const createApiClient = (baseURL) => {
  const apiClient = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  });

  // Interceptor để tự động thêm token vào header
  apiClient.interceptors.request.use(
    (config) => {
      const token = authService.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        // Tạm thời hardcode token cho testing (nên remove trong production)
        console.warn('No auth token found, using fallback for development');
        // config.headers.Authorization = 'Bearer your-dev-token-here';
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Interceptor để handle 401 errors và auto refresh token
  apiClient.interceptors.response.use(
    (response) => {
      // Đảm bảo response.data luôn tồn tại, nếu không thì set thành null
      if (response && !response.data) {
        response.data = null;
      }
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      
      // Đảm bảo error.response.data tồn tại để tránh lỗi JSON.parse(undefined)
      if (error.response && !error.response.data) {
        error.response.data = { message: 'No response data' };
      }
      
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        
        try {
          // Try to refresh token
          await authService.refreshTokenFn();
          
          // Retry original request với token mới
          const newToken = authService.getAccessToken();
          if (newToken) {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
          }
          
          return apiClient(originalRequest);
        } catch (refreshError) {
          // Refresh failed, logout user
          authService.clearTokens();
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
      
      return Promise.reject(error);
    }
  );

  return apiClient;
};

export default createApiClient;